import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { RegistrationAttendee } from '../../../shared/registration-attendee.model';

@Component({
  selector: 'wl-registration-wizard-attendee-tab-nav',
  templateUrl: 'registration-wizard-attendee-tab-nav.component.html',
  styleUrls: ['registration-wizard-attendee-tab-nav.component.css'],
    standalone: false
})
export class WLRegistrationWizardAttendeeTabNav {
  /**
   * attendees to show
   */
  @Input() attendees: Array<RegistrationAttendee> = [];

  /**
   * should the new button be enabled
   */
  @Input() enableNewButton: boolean = false;

  /**
   * event for new attendee
   */
  @Output() onAddAttendee: EventEmitter<void> = new EventEmitter<void>();

  /**
   * event for when they click an attendee link
   * Param is the index of the attendee clicked
   */
  @Output() onAttendeeClick: EventEmitter<number> = new EventEmitter<number>();

  /**
   * constructor
   */
  public constructor() {}

  /**
   * they clicked the "new attendee" button
   */
  public handleNewAttendeeClick() {
    this.onAddAttendee.emit();
  }

  /**
   * they click an attendee link
   * @param number
   */
  public handleAttendeeLinkClick(attendeeIndex: number) {
    if (attendeeIndex < 0 || !this.attendees) return;

    this.onAttendeeClick.emit(attendeeIndex);
  }
}
